import * as Yup from 'yup'

import { getAdLongHeadline } from '../../helpers'
import { longHeadlineMaxLength } from '../../../fields'
import { LONG_HEADLINE } from '../../../AdGoogleCreate/AdGoogleCreateForm/fields'

export const getInitialValues = ad => {
  const longHeadline = getAdLongHeadline(ad)

  return {
    [LONG_HEADLINE]: longHeadline || ''
  }
}

export const validationSchema = Yup.object({
  [LONG_HEADLINE]: Yup.string()
    .max(longHeadlineMaxLength, `Long headline should have maximum ${longHeadlineMaxLength} characters`)
    .required('This field should not be empty')
})
